import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 12,
    padding: 16
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 8
  },
  row2: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    marginBottom: 16
  },
  radioIcon: {
    '& svg': {
      fontSize: 18
    }
  },
  radioLabel: { color: theme.palette.text.primary, fontSize: 14, margin: 0 },
  methodSelector: {
    width: 'fit-content'
  },
  radioGroup: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 8,
    padding: 8,
    width: 'fit-content'
  },
  methodTitle: {
    fontSize: 14,
    marginBottom: 4,
    marginLeft: 12,
    color: theme.palette.text.primary
  }
}))

export default useStyles
